import { render, staticRenderFns } from "./WorksGroup.vue?vue&type=template&id=72b6ad47&"
import script from "./WorksGroup.vue?vue&type=script&lang=js&"
export * from "./WorksGroup.vue?vue&type=script&lang=js&"
import style0 from "./WorksGroup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports